module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-12c06395.svg";